import { render, staticRenderFns } from "./multipleUpload.vue?vue&type=template&id=2f622a6c&scoped=true"
import script from "./multipleUpload.vue?vue&type=script&lang=js"
export * from "./multipleUpload.vue?vue&type=script&lang=js"
import style0 from "./multipleUpload.vue?vue&type=style&index=0&id=2f622a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f622a6c",
  null
  
)

export default component.exports